module.exports = __webpack_public_path__ + "img/icon-check.db3b19b0.svg";